export const AUTH_LOGIN_ROUTE_SEGMENTS: string[] = ['auth', 'login'];
export const AUTH_REGISTER_ROUTE_SEGMENTS: string[] = ['auth', 'register'];
export const AUTH_USER_DETAILS_UPDATE: string[] = ['my-profile', ':step'];
